exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable td[data-v-72a1242c] {\n  font-weight: 500;\n}", ""]);

// exports
